import { Hero } from "@/components/Hero";
import { Problem } from "@/components/Problem";
import { Solution } from "@/components/Solution";
import { HowItWorks } from "@/components/HowItWorks";
import { Features } from "@/components/Features";
import { Privacy } from "@/components/Privacy";
import { Testimonials } from "@/components/Testimonials";
import { CTA } from "@/components/CTA";
import { Footer } from "@/components/Footer";
import { Navbar } from "@/components/Navbar";
import { ComingSoonBanner } from "@/components/ComingSoonBanner";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";


const Index = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Redirect authenticated users to settings
  useEffect(() => {
    if (user) {
      navigate('/settings', { replace: true });
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen">
      <ComingSoonBanner />
      <Navbar />
      <Hero />
      <Problem />
      <Solution />
      <HowItWorks />
      <Features />
      <Privacy />
      <Testimonials />
      <div id="waitlist">
        <CTA />
      </div>
      <Footer />
    </div>
  );
};

export default Index;
